module.exports = __webpack_public_path__ + "img/Discord-Logo-White.56c5907.png";